import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatClassTime } from '../../utils/classModalHelpers';

export default function ClassDetails({
    cls,
    userRole,
    isClassFull,
    isRegistered,
    isInWaitlist,
    waitlistCount,
    attendees,
    guestRegistrations,
    selectedAffiliateListVisible,
    isAllClassListVisible,
    hasAnyPlans = false,
    hideTrainer = false
}) {
    // Calculate current enrolled count dynamically
    // Use live count if data was fetched (affiliate, trainer, or viewing specific lists)
    // Otherwise use cls.enrolledCount from server
    const shouldUseLiveCount = 
        userRole === "affiliate" || 
        userRole === "trainer" || 
        selectedAffiliateListVisible === true || 
        (isAllClassListVisible === true && hasAnyPlans === true);
    
    const currentEnrolledCount = shouldUseLiveCount
        ? (attendees?.length || 0) + (guestRegistrations?.length || 0)
        : (cls.enrolledCount || 0);
    return (
        <Box
            sx={{
                backgroundColor: "background.paper",
                padding: 2,
                borderRadius: "8px",
            }}
        >
            <Typography
                variant="h6"
                sx={{ fontWeight: "bold", marginBottom: 1 }}
            >
                Class Details
            </Typography>
            <Typography>
                <strong>🕒 Time:</strong>{" "}
                {formatClassTime(cls.time)}
            </Typography>
            {!hideTrainer && cls.trainer && (
                <Typography>
                    <strong>🏋️ Coach:</strong> {cls.trainer}
                </Typography>
            )}
            {cls.location && (
                <Typography>
                    <strong>📍 Location:</strong> {cls.location}
                </Typography>
            )}
            <Typography>
                <strong>👥 Capacity:</strong> {currentEnrolledCount} / {cls.memberCapacity}
                {/* Show waitlist count if class is full and user is regular */}
                {isClassFull && userRole === 'regular' && waitlistCount > 0 && (
                    <span style={{ color: '#ff9800', marginLeft: '8px' }}>
                        (Waitlist: {waitlistCount})
                    </span>
                )}
            </Typography>
            <Typography>
                <strong>🏃 Training Type:</strong> {cls.trainingType || "N/A"}
            </Typography>
            {isClassFull && !isRegistered && !isInWaitlist && userRole === 'regular' && (
                <Typography color="error" sx={{ mt: 1, fontWeight: "bold" }}>
                    This class is full. You can join the waitlist.
                    {waitlistCount > 0 && (
                        <span style={{ color: '#ff9800' }}>
                            {' '}({waitlistCount} {waitlistCount === 1 ? 'person' : 'people'} currently waiting)
                        </span>
                    )}
                </Typography>
            )}
            {isInWaitlist && userRole === 'regular' && (
                <Typography color="primary" sx={{ mt: 1, fontWeight: "bold" }}>
                    You are on the waitlist for this class.
                </Typography>
            )}
        </Box>
    );
}

